<template>
  <div class="sidebar-filters">
    <b-button class="text-uppercase" ref="escape" variant="reset-all" @click.prevent="resetFilters()">
      <i class="fas fa-eraser" /> {{ 'Reset all filters' | translate }}
    </b-button>
    <status-list-filter
      @edit="editComponentFilters($event, 'filter__status__in')"
      @clean="cleanComponentFilters(['filter__status__in'])"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { TYPES as CONTRACT_TYPOLOGY_TYPES } from './store'
import CommonFiltersMixin from '../../common-filters/CommonFiltersMixin'

export default {
  name: 'ContractTypologyCommonFilters',
  mixins: [CommonFiltersMixin],
  computed: {
    ...mapGetters({
      filters: CONTRACT_TYPOLOGY_TYPES.GENERIC.organization.contracttypology.LIST.GETTERS.filters
    })
  },
  methods: {
    ...mapActions({
      ...CONTRACT_TYPOLOGY_TYPES.GENERIC.organization.contracttypology.LIST.ACTIONS
    })
  }
}
</script>
